// ja strings for messages/voice.ts. Same keys and {variables} as en there.
// SEO follows how Japanese users search: 「{name} AIボイス」「{name} AIカバー」.
import type { Dict } from "../index";

const voice: Dict = {
  // <head> and JSON-LD
  "voice.seo.title": "{name}のAIボイス：試聴してAIカバーを作成 | Jammable",
  "voice.seo.description":
    "{name}のAIカバーを試聴して、約1分で自分のカバーを作成。コミュニティが作った{name}のAIボイスで、歌やテキスト読み上げ、デュエットをJammableで楽しめます。",
  "voice.seo.appName": "{name}のAIボイスジェネレーター",
  "voice.seo.private": "非公開のボイス | Jammable",
  "voice.name": "{name}のAIボイス",

  // Removed / private
  "voice.removed": "このボイスは削除されました。",
  "voice.private": "このボイスは非公開です。",
  "voice.browseOther": "他のボイスを見る",

  "voice.error": "問題が発生しました。もう一度お試しください",
  "voice.copied": "クリップボードにコピーしました！",

  // Hero
  "voice.newer.body":
    "{username}がこのボイスを更新しました。新しいバージョンを試してみましょう",
  "voice.newer.cta": "新しいバージョン",
  "voice.communityFavourite": "コミュニティで人気",
  // {name} is replaced by the uploader's name, styled separately.
  "voice.uploadedBy": "アップロード：{name}",
  "voice.voices.one": "{n}ボイス",
  "voice.voices.other": "{n}ボイス",
  "voice.createCover": "カバーを作成 · {uses}回使用",
  "voice.like": "ボイスにいいね",
  "voice.unlike": "いいねを取り消す",
  "voice.comments": "コメント",
  "voice.saveToCollection": "コレクションに保存",
  "voice.share": "ボイスを共有",
  "voice.edit": "ボイスを編集",
  "voice.report": "ボイスを報告",
  "voice.delete": "ボイスを削除",
  "voice.more": "その他",
  "voice.description": "説明",

  "voice.discord.label": "コミュニティで{name}について話そう",
  "voice.discord.labelNoName": "コミュニティでAIボイスについて話そう",
  "voice.discord.body":
    "Discordでカバーを共有したり、新しいボイスをリクエストしたり、コツを教わったりできます",

  // Related voices. {badge} is the voice's category as stored (English).
  "voice.similar.title": "{name}に似たAIボイス",
  "voice.similar.sub": "{name}と一緒によく使われているボイスです。",
  "voice.similar.moreHub": "{badge}のボイスをもっと見る",
  "voice.popularHub.title": "人気の{badge} AIボイス",
  "voice.seeAll": "すべて見る",
  "voice.collections.title": "{name}を含むコレクション",
  "voice.collections.titleNoName": "このボイスを含むコレクション",
  "voice.pairWell.title": "{name}と相性のいいボイス",

  // About
  "voice.about.title": "{name}のAIボイスについて",
  "voice.about.use":
    "{name}のAIボイスは、AIカバーの作成、ボイスチェンジャー、テキスト読み上げに使えます。",
  "voice.about.categorised": "カテゴリ：{list}。",
  "voice.about.uses": "このボイスはJammableで{n}回使われています。",
  "voice.howTo.title": "{name}のAIカバーの作り方",

  // FAQ
  "voice.faq.title": "{name}のAIボイスに関するよくある質問",
  "voice.faq.sub": "{name}のボイスでカバーを作るための情報まとめ。",
  "voice.link.aiCover": "AIカバー作成",
  "voice.link.voiceChanger": "AIボイスチェンジャー",
  "voice.link.browseAll": "すべてのAIボイスを見る",
  "voice.link.weights": "Weights.ggの代わりに",
  "voice.faq.how.q": "{name}のAIカバーはどうやって作りますか？",
  // {dmca} becomes the DMCA Policy link.
  "voice.faq.how.a":
    "{name}のAIカバーを作るには、スタジオで自分の音声を追加してください（{dmca}をお読みください）。追加したら、変換ボタンを押すだけです。{name}のAIカバーは約30〜60秒で完成します。",
  "voice.faq.dmca": "DMCAポリシー",
  "voice.faq.input.q": "{name}のAIカバーにはどんな音声を使えますか？",
  "voice.faq.input.a":
    "アップロードできるのは、あなた自身のオリジナル音声のみです。第三者の著作物を含む録音は、権利者の許可なく使用しないでください。",
  "voice.faq.time.q": "{name}のAIカバーはどのくらいでできますか？",
  "voice.faq.time.a": "{name}のAIカバーは約30〜60秒で完成します！",
  "voice.faq.credits.q":
    "{name}のAIカバー1曲につき、クレジットはいくつ使いますか？",
  "voice.faq.credits.a":
    "{name}のAIカバー1曲につき、使うのは1クレジットだけです！",
  "voice.faq.acapella.q": "アカペラをアップロードする必要はありますか？",
  "voice.faq.acapella.a":
    "いいえ、アカペラをアップロードする必要はありません。{name}のAIカバー用に、システムが自動でボーカルを抽出します！",
  "voice.faq.changer.q":
    "{name}のAIボイスをボイスチェンジャーとして使えますか？",
  "voice.faq.changer.a":
    "はい。{name}のAIボイスはボイスチェンジャーやテキスト読み上げにも使えます。音声をアップロードまたは録音すれば、数秒で{name}の声に変換できます。",
  "voice.faq.free.q": "{name}のAIボイスは無料ですか？",
  "voice.faq.free.a":
    "{name}のAIボイスのデモ試聴とカバーの準備は無料です。カバーの作成にはJammableのプランが必要で、プランに加入すると{name}のAIカバーを無制限に作成・ダウンロードできるなど、さまざまな特典があります。",

  // TryVoiceSection
  "voice.demos.title": "まずは試聴",
  "voice.demos.note":
    "デモはボイスの品質を確認できるよう自動生成されています。",
  "voice.demos.maleSinging": "男性ボーカル {n}",
  "voice.demos.femaleSinging": "女性ボーカル {n}",
  "voice.demos.english": "英語",
  "voice.play": "{name}を再生",
  "voice.pause": "{name}を一時停止",

  // LibraryDemosSection
  "voice.library.title": "このボイスで歌った曲",
  "voice.library.sub":
    "{name}のAIボイスがライブラリの人気曲を歌っています。聴いてみましょう。",
  "voice.library.unknownSong": "不明な曲",
  "voice.library.unknownArtist": "不明なアーティスト",

  // ModelCommentSection / ModelCommentItem
  "voice.comments.count.one": "{n}件のコメント",
  "voice.comments.count.other": "{n}件のコメント",
  "voice.comments.add": "コメントを追加",
  "voice.comments.post": "投稿",
  "voice.comments.top": "人気順",
  "voice.comments.newest": "新しい順",
  "voice.comments.empty": "まだコメントはありません...",
  "voice.comments.emptySub": "最初のコメントを書いてみましょう！",
  "voice.comments.more": "コメントをもっと見る",
  "voice.comments.posted": "コメントを投稿しました！",
  "voice.comments.avatarAlt": "ユーザーのアバター",
  "voice.comments.creator": "作成者",
  "voice.comments.pinned": "固定",
  "voice.comments.reply": "返信",
  "voice.comments.replyLabel": "コメントへの返信",
  "voice.comments.replyPlaceholder": "どう思いますか？",
  "voice.comments.viewReply.one": "{n}件の返信を表示",
  "voice.comments.viewReply.other": "{n}件の返信を表示",
  "voice.comments.viewMore": "さらに{n}件を表示",
  "voice.comments.justNow": "たった今",
  "voice.comments.minutes": "{n}分前",
  "voice.comments.hours": "{n}時間前",
  "voice.comments.days": "{n}日前",
  "voice.comments.repliesFailed": "返信を読み込めませんでした",
  "voice.comments.pinnedToast": "コメントを固定しました！",
  "voice.comments.unpinnedToast": "コメントの固定を解除しました！",
  "voice.comments.pinFailed": "コメントを固定できませんでした",
  "voice.comments.pin": "コメントを固定",
  "voice.comments.unpin": "固定を解除",
  "voice.comments.delete": "コメントを削除",
  "voice.comments.report": "コメントを報告",

  // AddToCollectionModal
  "voice.addTo.title": "コレクションに追加",
  "voice.addTo.error": "コレクションを読み込めませんでした：{message}",
  "voice.addTo.empty": "コレクションが見つかりません...",
  "voice.addTo.emptySub": "最初のコレクションを作りましょう！",
  "voice.addTo.new": "新しいコレクション",
};

export default voice;
